import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleSideNav } from '../actions/navActions';

// Components
import Avatar_For_Headers from './common/Avatar_For_Headers';
import Logo from './common/Logo_Round';

// Icons
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
  
const Navbar = ({
    auth: {
        isAuthenticated,
        isPremium
    },
    toggleSideNav
}) =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	  <div style={{zIndex: 50, position: 'fixed', paddingTop: '8px', paddingLeft: '0', paddingRight: '0', display: 'flex', justifyContent: 'center', width: '100%', background: '#000'}}>
        <div style={{height: '4rem', width: '100%', paddingLeft: '1.5rem', paddingRight: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            {/* Logo Container */}
            <div onClick={() => window.location = '/'} style={{gap: '.5rem', display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                {/* Img - Logo */}
                <img alt="Interview Cheater" loading="lazy" width="20" height="20" decoding="async" src={Logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                {/* Text - Logo */}
                <span style={{fontWeight: 600, fontSize: '.875rem', lineHeight: '1.25rem'}}>
                    Interview Cheater
                </span>
            </div>

            {!isMobile ? (
                <Fragment>
                    {/* Navigation Links */}
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2rem'}}>
                        {/* Option - Link */}
                        <div className='white_hover' style={{color: 'rgb(152, 152, 152)', fontSize: '1rem', fontWeight: 500, lineHeight: '1.25rem', textDecoration: 'none', cursor: 'pointer'}} onClick={() => {
                            // Smooth scroll logic
                            const proof_Ref = document.getElementById('proof');

                            proof_Ref?.scrollIntoView({
                                behavior: 'smooth'
                            })
                        }}>
                            Proof
                        </div>
                        {/* Option - Link */}
                        <a href="/help" className='white_hover' style={{color: 'rgb(152, 152, 152)', fontSize: '1rem', fontWeight: 500, lineHeight: '1.25rem', textDecoration: 'none'}}>
                            Help
                        </a>
                        {/* Option - Link */}
                        <div className='white_hover' style={{color: 'rgb(152, 152, 152)', fontSize: '1rem', fontWeight: 500, lineHeight: '1.25rem', textDecoration: 'none', cursor: 'pointer'}} onClick={() => {
                            // Smooth scroll logic
                            const pricing_Ref = document.getElementById('pricing');

                            pricing_Ref?.scrollIntoView({
                                behavior: 'smooth'
                            })
                        }}>
                            Pricing
                        </div>
                    </div>

                    {/* Call to action Buttons */}
                    {!isAuthenticated ? (
                        <div style={{gap: '1rem', display: 'flex', alignItems: 'center'}}>
                            {/* Button */}
                            <a href="/signin">
                                <button style={{color:'rgb(152,152,152)', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', paddingTop: '.5rem', paddingBottom: '.5rem', paddingLeft: '1rem', paddingRight: '1rem', borderRadius: '14px', border: 'none', background: 'none', cursor: 'pointer'}}>
                                    Login
                                </button>
                            </a>
                            {/* Button */}
                            <a href="/signup">
                                <button style={{boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', paddingTop: '.5rem', paddingBottom: '.5rem', paddingLeft: '1rem', paddingRight: '1rem', borderRadius: '14px', cursor: 'pointer'}}>
                                    Sign Up
                                </button>
                            </a>
                        </div>
                    ) : (
                        <div style={{gap: '1rem', display: 'flex', alignItems: 'center'}}>
                            {!isPremium && (
                                <a href="/checkout">
                                    <button className='button_hover' style={{boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', paddingTop: '.5rem', paddingBottom: '.5rem', paddingLeft: '1rem', paddingRight: '1rem', borderRadius: '14px', cursor: 'pointer'}}>
                                        <div style={{display: 'flex', gap: '.5rem', alignItems: 'center'}}>
                                            <LockOutlinedIcon />
                                            Subscribe
                                        </div>
                                    </button>
                                </a>
                            )}
                            {/* Avatar + dropdown */}
                            <div className='button_hover' style={{position:'relative', display: 'flex', alignItems: 'center'}}>
                            
                                <Avatar_For_Headers />
                            </div>
                        </div>
                    )}
                </Fragment>
            ) : (
                <div className="menu_btn" onClick={() => toggleSideNav()}>
                    <MenuOutlinedIcon />
                </div>
            )}
        </div>
	  </div>
	);
}
  
Navbar.propTypes = {
    auth: PropTypes.object.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component
    toggleSideNav
})(Navbar);
  